import { useGetFrontTipiUtente } from '@framework/api-client';
import { ISelectInputProps, SelectInput } from '@framework/form';
import * as React from 'react';
import { useMemo } from 'react';

export interface IInquiryRecipientTypeSelectInputProps
  extends ISelectInputProps {}

export function InquiryRecipientTypeSelectInput(
  props: IInquiryRecipientTypeSelectInputProps,
) {
  const { data: userKinds, isLoading } = useGetFrontTipiUtente({
    query: { keepPreviousData: true },
  });

  const options = useMemo(() => {
    return (
      userKinds?.map(userKind => ({
        value: userKind.id!,
        label: userKind.descrizione!,
      })) ?? null
    );
  }, [userKinds]);

  return (
    <SelectInput
      {...props}
      optionFilterProp="label"
      style={{ width: '100%' }}
      loading={isLoading}
      options={options}
    />
  );
}
